import React, {useEffect, useState} from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import classes from "./Experience.module.css";
import Switch from "../../../../UI/Switch/Switch";
import Grid from "@material-ui/core/Grid";
import {Col, Form, Row} from "react-bootstrap";
import {translation} from "../../../../../I18n/i18n";
import SpellChecker from "../../../../UI/SpellChecker/SpellChecker";
import {CardActions} from "@mui/material";
import {isFilled} from "../../../../UI/SpellChecker/utils";
import {MAX_INPUT_DATE} from "../../../../../applicationConstants";

const moment = require ("moment");

const FormExperience = (props) => {

    const [position, setPosition] = useState (props.experience.Position.Label._text);
    const [employer, setEmployer] = useState (props.experience.Employer.Name._text);
    const [from, setFrom] = useState (props.experience.Period.From);
    const [to, setTo] = useState (props.experience.Period.To);
    const [fromToBeChecked, setFromToBeChecked] = useState ("");
    const [toToBeChecked, setToToBeChecked] = useState ("");
    const [projectDescription, setProjectDescription] = useState (props.experience.ProjectDescription ? props.experience.ProjectDescription._cdata : "");
    const [responsibilities, setResponsibilities] = useState (props.experience.Responsibilities ? props.experience.Responsibilities._cdata : "");
    const [environment, setEnvironment] = useState (props.experience.Environment ? props.experience.Environment._cdata : "");

    const [current, setCurrent] = useState (props.experience.Period.Current._text === "true");
    const [dateToBeStored,setDateToBeStored]=useState()
    const [dateToBeDisplayed,setDateToBeDisplayed]=useState()
    useEffect (() => {
        props.setEditingExperience ({index: props.editingExperience.index, experience:{
            Period: {From: from, To: to, Current: {_text: current ? 'true' : 'false'}},
            Position: {
                Label: {
                    _text: position
                }
            },
            Activities: {},
            ProjectDescription: {_cdata: projectDescription},
            Responsibilities: {_cdata: responsibilities},
            Environment: {_cdata: environment},
            Employer: {Name: {_text: employer}},
        }})
    }, [from, to, current, position, projectDescription, responsibilities, environment, employer])

    // pass updateExpr() function to the 'CVDetails' parent component.
    useEffect (() => props.setUpdateExpr (() => () => {
        props.setEditingExperience ({index: props.editingExperience.index, experience:{
            Period: {From: from, To: to, Current: {_text: current ? 'true' : 'false'}},
            Position: {
                Label: {
                    _text: position
                }
            },
            Activities: {},
            ProjectDescription: {_cdata: projectDescription},
            Responsibilities: {_cdata: responsibilities},
            Environment: {_cdata: environment},
            Employer: {Name: {_text: employer}},
        }});
        props.refresh ();
    }), []);

    useEffect(() => props.setIsAnyEmptyExprField (() => () => {
        return position === "" ||
            employer === "" ||
            (from._attributes.month === "" && from._attributes.year === "") ||
            (to._attributes.month === "" && to._attributes.year === "" && !current) ||
            !isAcceptedPeriod () ||
            !isFilled(projectDescription) ||
            !isFilled(responsibilities)
    }), [from, to, current, position, employer, fromToBeChecked, toToBeChecked,responsibilities,projectDescription]);

    let fitDateToStorage = (d) => {
        let month = new Date (d.target.value).getMonth () + 1;
        let year = new Date (d.target.value).getFullYear ();

        return {
            "_attributes": {
                "month": month < 10 ? `--0${ month }` : `--${ month }`,
                "year": year.toString ()
            }
        };
    }

    let fitDateToDisplay = (d) => {
        return d._attributes.year === "" && d._attributes.month === "" ? `jj/mm/aaaa`
            : moment (
                (`${ d._attributes.year }/${ d._attributes.month }/01`)
                    .replace ("--", "")).format ("YYYY-MM-DD");
    }

    useEffect (() => {
        setToToBeChecked (fitDateToDisplay (to))
        setFromToBeChecked (fitDateToDisplay (from))
    }, [])

    let isAcceptedPeriod = () => {
        return (fromToBeChecked !== '' && toToBeChecked !== '' && fromToBeChecked !== 'jj/mm/aaaa' && toToBeChecked !== 'jj/mm/aaaa' ? (current ? new Date (fromToBeChecked) < new Date () : new Date (fromToBeChecked) < new Date (toToBeChecked)) : true)
    }

    let errorMessageRelatedToDate = !isAcceptedPeriod () ? (
        <small id="passwordHelp" className="text-danger">
            { translation (props.lang, "Must be Higher than From Date") }
        </small>
    ) : null;

    return (
        <div className={ classes.experience }>
            <Card key={ props.index }>
                <CardHeader
                    titleTypographyProps={ {variant: 'h6'} }
                    title={ props.title } subheader=""/>

                <Grid className={ classes.editFormStyle } container spacing={ 3 }>
                    <Grid item xs={ 12 }>
                        <Form>
                            <Form.Group as={ Row }>
                                <Form.Label column sm="1">{ translation (props.lang, "Position") }
                                    <span className={ classes.required }>*</span>
                                </Form.Label>

                                <Col sm="5">
                                    <SpellChecker
                                        dict={ props.dict }
                                        notify={ props.notify }
                                        addToDictionary={ props.addToDictionary }
                                        lang={ props.lang }
                                        value={ position }
                                        onChange={ (v) => {
                                            setPosition (v)
                                        } }
                                    />
                                </Col>
                                <Form.Label column sm="1">{ translation (props.lang, "Company") }
                                    <span className={ classes.required }>*</span>
                                </Form.Label>

                                <Col sm="5">
                                    <SpellChecker
                                        dict={ props.dict }
                                        notify={ props.notify }
                                        addToDictionary={ props.addToDictionary }
                                        lang={ props.lang }
                                        value={ employer }
                                        onChange={ (v) => {
                                            setEmployer (v)
                                        } }
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={ Row }>
                                <Form.Label column sm="1">{ translation (props.lang, "From") }
                                    <span className={ classes.required }>*</span>
                                </Form.Label>

                                <Col sm="5">

                                    <Form.Control type="date"
                                                  defaultValue={ fitDateToDisplay (from) }
                                                  onChange={ (e, v) => {
                                                      setFrom (fitDateToStorage (e));
                                                      setFromToBeChecked (e.target.value)
                                                  } }
                                                  max={MAX_INPUT_DATE}
                                    />
                                </Col>
                                <Form.Label column sm="1">{ translation (props.lang, "To") }
                                    <span className={ classes.required }>*</span>
                                </Form.Label>

                                <Col sm="3">

                                    <Form.Control type="date"
                                                  disabled={ current }
                                                  value={ toToBeChecked }
                                                  onChange={ (e, v) => {
                                                      setTo (fitDateToStorage (e));
                                                      setToToBeChecked (e.target.value);
                                                      setDateToBeDisplayed(e.target.value);
                                                  } }
                                                  max={MAX_INPUT_DATE}
                                    />
                                    { errorMessageRelatedToDate }
                                </Col>

                                <Switch
                                    checked={ current }
                                    size={ "small" }
                                    color={ "primary" }
                                    label={ translation (props.lang, "Current ?") }
                                    updateValue={ (v) => {
                                        setCurrent (v);
                                        if (v) {
                                            setToToBeChecked (new Date ())
                                            setDateToBeStored(to);
                                            setTo ({"_attributes": {"month": "", "year": ""}});
                                        } else {
                                            setTo (dateToBeStored===undefined?{"_attributes": {"month": "", "year": ""}}:dateToBeStored);
                                            setToToBeChecked (dateToBeDisplayed===undefined ?dateToBeStored!==undefined?fitDateToDisplay(dateToBeStored):"":dateToBeDisplayed)
                                        }
                                        props.experience.Period.Current._text = v.toString ();
                                    } }
                                />
                            </Form.Group>

                        </Form>
                        <SpellChecker freeTextBox
                                      dict={ props.dict }
                                      notify={ props.notify }
                                      addToDictionary={ props.addToDictionary }
                                      lang={ props.lang }
                                      onChange={ setProjectDescription }
                                      placeholder={ `${ translation (props.lang, "Project Description") } ...` }
                                      value={ projectDescription }
                                      onlyText={true}
                        />
                        <br/>
                        <SpellChecker freeTextBox
                                      multilevelTool
                                      dict={ props.dict }
                                      notify={ props.notify }
                                      addToDictionary={ props.addToDictionary }
                                      lang={ props.lang }
                                      onChange={ setResponsibilities }
                                      placeholder={ `${ translation (props.lang, "Responsibilities") } ...` }
                                      value={ responsibilities }
                                      onlyBulletPoint={true}
                        />
                        <br/>
                        <SpellChecker freeTextBox
                                      multilevelTool
                                      dict={ props.dict }
                                      notify={ props.notify }
                                      addToDictionary={ props.addToDictionary }
                                      lang={ props.lang }
                                      onChange={ setEnvironment }
                                      placeholder={ `${ translation (props.lang, "Environment") } ...` }
                                      value={ environment }
                        />
                    </Grid>
                </Grid>
            <CardActions/>
            </Card>
        </div>
    );
};

export default FormExperience;
